const $ = window.jQuery;
const Hammer = window.Hammer;
const isDesktop = window.matchMedia("(min-width: 768px)");
const getEventConfig = window.getEventConfig;
const config = getEventConfig();

/**
 * Time constants
 * @type {Object}
 */
const TIME = {
	FADE: {
		DEFAULT: 300,
		SHORT: 100,
	},
	THROTTLE: 100,
	DEBOUNCE: 100,
};

export function addVoidForLinks(links) {
	$.each(links, (index, element) => {
		const link = $(element);
		if (link.attr(`href`) === `` || link.attr(`href`) === `#`) {
			link.attr(`href`, `javascript:void(0)`);
		}
	});
}

// a11y hamburger https://foxland.fi/simple-accessible-svg-menu-hamburger-animation
export function hamburger(element) {
	const button = document.getElementById(element);

	if (!button) {
		return false;
	}
	button.onclick = () => {
		if (button.className.indexOf("opened") !== -1) {
			button.className = button.className.replace(" opened", "");
			button.setAttribute("aria-expanded", "false");
			document.querySelector(`.body`).classList.remove(`body_overlay`);
			$(".header__enter").hide();
		} else {
			button.className += " opened";
			button.setAttribute("aria-expanded", "true");
			document.querySelector(`.body`).classList.add(`body_overlay`);
			$("#js-header-left").html($(".header__enter"));
			$(".header__enter").show();
			$(".js-header-logout").prependTo(".header__links");
			$(".js-header-login").prependTo(".js-header-top");
			$(".header__hover").insertAfter(".dropdown_header");
		}
	};

	return false;
}

export function insertDataToTicket(item, isPack) {
	let sector = item.sector;
	let price;
	let name = item.name;

	if (item.price) {
		price = item.price;
	} else {
		price = "";
	}
	if (sector) {
		name = name.replace("Сектор " + sector, "");
		sector = `Сектор ${sector}`;
	}
	return `<div class="tickets__item js-ticket-template" data-id="${item.id}" data-place="${item.sid}" data-uid="${item.uid}" data-ispack="${isPack}">
					<div class="tickets__content">
						<div class="tickets__sector">${sector}</div>
						<div class="tickets__place"><span class="js-ticket-place">${name}</span>
						<span class="tickets__dots"></span>
						<span class="tickets__place-price">
						<span class="js-ticket-price">${price}</span>
						₽</span>
					</div>
					<div class="tickets__remove js-tickets-remove">
						<button class="tickets__remove-button"  type="button" data-selenium="event_seat_delete">Удалить</button>
					</div>
					</div>
					</div>`;
}

export function setObjectToSessionStorage(name, object) {
	sessionStorage.setItem(name, JSON.stringify(object));
}

export function getObjectFromSessionStorage(name) {
	if (sessionStorage.getItem(name)) {
		return JSON.parse(sessionStorage.getItem(name));
	}
	return false;
}

/**
 * Function to throttle the execution of event handlers
 * @param  {Function} callback
 * @param  {Number|undefined} delay
 * @return {Function}
 */
export function throttle(callback, delay) {
	let hold = false;
	delay = delay || TIME.THROTTLE;

	return function handleEvent(...args) {
		if (hold) return;

		hold = true;
		callback.apply(this, args);

		window.setTimeout(() => {
			hold = false;
		}, delay);
	};
}

export function viewPromoButton() {
	const promo = $(".js-promo");
	$.each(promo, (index, element) => {
		const promoInput = $(element).find(".promo__input");
		promoInput.on("keypress", () => {
			$(element).addClass("active");
		});

		promoInput.on("focus", () => {
			$(element).addClass("focus");
		});

		promoInput.on("blur", () => {
			$(element)
				.removeClass("active")
				.removeClass("focus");

			if (promoInput.val()) {
				$(element)
					.addClass("active")
					.removeClass("focus");
			}
		});
	});
}

export const hammerEventsHandler = {
	haltEventListeners: ["touchstart", "touchend", "touchmove", "touchleave", "touchcancel"],
	init(options) {
		const instance = options.instance;
		let initialScale = 1;
		let pannedX = 0;
		let pannedY = 0;
		// Init Hammer
		// Listen only for pointer and touch events
		this.hammer = Hammer(options.svgElement, {
			inputClass: Hammer.SUPPORT_POINTER_EVENTS
				? Hammer.PointerEventInput
				: Hammer.TouchInput,
		});
		// Enable pinch
		this.hammer.get("pinch").set({enable: true});
		// Handle double tap
		this.hammer.on("doubletap", () => {
			instance.zoomIn();
		});
		// Handle pan
		this.hammer.on("panstart panmove", ev => {
			// On pan start reset panned variables
			if (ev.type === "panstart") {
				pannedX = 0;
				pannedY = 0;
			}
			// Pan only the difference
			instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY});
			pannedX = ev.deltaX;
			pannedY = ev.deltaY;
		});
		// Handle pinch
		this.hammer.on("pinchstart pinchmove", ev => {
			// On pinch start remember initial zoom
			if (ev.type === "pinchstart") {
				initialScale = instance.getZoom();
				instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y});
			}
			instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y});
		});
		// Prevent moving the page on some devices when panning over SVG
		options.svgElement.addEventListener("touchmove", e => {
			e.preventDefault();
		});
	},
	destroy() {
		this.hammer.destroy();
	},
};

export function updateAllSums(item) {
	const eventSum = $(".js-event-summ");
	$.each(eventSum, (index, element) => {
		$(element).text(Number($(element).text()) + Number(item.price));
	});
}

export function convertToServerDate(timestamp) {
	const date = new Date(timestamp);
	return `${`0${date.getDate()}`.substr(-2, 2)}-${date.getMonth() +
	1}-${`${date.getFullYear()}`.substr(-2, 2)}`;
}

function setCookie(name, value, options) {
	options = options || {};

	let expires = options.expires;

	if (typeof expires === "number" && expires) {
		const d = new Date();
		d.setTime(d.getTime() + expires * 1000);
		expires = options.expires = d;
	}
	if (expires && expires.toUTCString) {
		options.expires = expires.toUTCString();
	}

	value = encodeURIComponent(value);

	let updatedCookie = `${name}=${value}`;

	for (const propName in options) {
		updatedCookie += `; ${propName}`;
		const propValue = options[propName];
		if (propValue !== true) {
			updatedCookie += `=${propValue}`;
		}
	}
	document.cookie = updatedCookie;
}

export function setCityToCookie() {
	$(".js-city-name").on("click", e => {
		const element = $(e.currentTarget);
		const city = element.data("id");
		setCookie("city_id", city, {path: "/", "max-age": "36000000"});
		window.location.assign("/");
	});
}

export function removeLoader(img) {
	const image = document.querySelector(img);
	if (!image) {
		return false;
	}
	image.addEventListener("load", () => {
		image.nextElementSibling.remove();
	});

	return true;
}

export function lazyLoading() {
	if ("loading" in HTMLImageElement.prototype) {
		const images = document.querySelectorAll("img.lazyload");
		images.forEach(img => {
			img.src = img.dataset.src;
		});
	} else {
		const script = document.createElement("script");
		script.async = true;
		script.src = "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js";
		document.body.appendChild(script);
	}
}

export function menuOnMobile() {
	$(".js-menu-next").on("click", e => {
		const element = $(e.currentTarget);
		const menuList = element.parents(".js-menu").find(".js-menu-list");
		const items = menuList.find(".js-menu-item");
		const currentPosition = menuList[0].scrollLeft;
		$.each(items, (index, el) => {
			const item = $(el);
			const itemPosition =
				item[0].getBoundingClientRect().x || item[0].getBoundingClientRect().left;
			if (itemPosition > currentPosition) {
				const itemWidth = item[0].getBoundingClientRect().width;
				menuList[0].scrollLeft = itemPosition + itemWidth + 30;
				return false;
			}
			menuList[0].scrollLeft = menuList[0].getBoundingClientRect().width;
			return true;
		});
	});
}

export function convertStringToObject(str) {
	const properties = str.split(",");
	const obj = {};
	properties.forEach(property => {
		const tup = property.split(":");
		obj[tup[0]] = tup[1];
	});
	return obj;
}

export function profileSubmenu() {
	const link = document.querySelector(".header__link_profile");

	if (isDesktop.matches && link) {
		if (link.nextElementSibling) {
			link.addEventListener("focus", () => {
				link.parentNode.classList.add("focus");
			});
			link.addEventListener("blur", () => {
				link.parentNode.classList.remove("focus");
			});
			const subMenu = link.nextElementSibling;
			const subMenuLinks = subMenu.querySelectorAll("a");
			const lastLinkIndex = subMenuLinks.length - 1;
			const lastLink = subMenuLinks[lastLinkIndex];

			lastLink.addEventListener("blur", () => {
				link.parentElement.classList.remove("focus");
			});
		}
	}
}

export function insertCategoriesToSearchResults(category) {
	const categoryName = config.menu.find(item => {
		return Number(item.id) === category;
	});
	return `
	<div class="search-result__block" data-category="${category}">
		<div class="search-result__category">${categoryName.name}</div>
			<div class="search-result__items"></div>
		</div>
	`;
}

export function insertEventsToSearchResults(event) {
	const blocks = $(".search-result__block");

	blocks.each((index, block) => {
		const category = $(block).data("category");
		const items = $(block).find(".search-result__items");

		if (event.menuId === category) {
			const item = `<div  class="search-result__item">
<a href="/event?id_event=${event.eventId}" class="search-result__name">${event.name}</a>
<a href="/object?id=${event.objectId}" class="search-result__object">${event.object}</a>
</div>`;
			items.append(item);
		}
	});
}

export function scorePassword(pass) {
	let score = 0;
	if (!pass) return score;

	// award every unique letter until 5 repetitions
	const letters = {};
	for (let i = 0; i < pass.length; i++) {
		letters[pass[i]] = (letters[pass[i]] || 0) + 1;
		score += 5.0 / letters[pass[i]];
	}

	// bonus points for mixing it up
	const variations = {
		digits: /\d/.test(pass),
		lower: /[a-z]/.test(pass),
		upper: /[A-Z]/.test(pass),
		nonWords: /\W/.test(pass),
	};

	let variationCount = 0;
	for (const check in variations) {
		variationCount += variations[check] === true ? 1 : 0;
	}
	score += (variationCount - 1) * 10;

	return parseInt(score);
}

export function checkPassStrength(pass) {
	const score = scorePassword(pass);
	if (score > 80) return "strong";
	if (score > 60 || pass.length >= 6) return "middle";
	if (score >= 5) return "weak";

	return "";
}
